import { S3Client, PutObjectCommand, GetObjectCommand } from "@aws-sdk/client-s3";
import { Buffer } from "buffer";

if (!window.Buffer) {
  window.Buffer = Buffer;
}

// S3クライアントの設定
const REGION = "ap-northeast-3"; // 例: 大阪リージョン
const BUCKET_NAME = "calling-job-db";
const FILE_KEY = "data/tokens.json"; // トークンデータを保存するファイル名

const s3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

// トークンデータをS3に保存
export const saveTokensToS3 = async (tokens) => {
  try {
    const params = {
      Bucket: BUCKET_NAME,
      Key: FILE_KEY,
      Body: JSON.stringify(tokens),
      ContentType: "application/json",
    };
    await s3Client.send(new PutObjectCommand(params));
    console.log("Tokens saved to S3 successfully.");
  } catch (error) {
    console.error("Failed to save tokens to S3:", error);
    throw new Error("Failed to save tokens to S3.");
  }
};

// S3からトークンデータを取得
export const loadTokensFromS3 = async () => {
    try {
      const params = {
        Bucket: BUCKET_NAME,
        Key: FILE_KEY,
      };
      const data = await s3Client.send(new GetObjectCommand(params));
      const chunks = [];
      for await (const chunk of data.Body) {
        chunks.push(chunk);
      }
      const fileContent = Buffer.concat(chunks).toString("utf-8");
      const tokens = JSON.parse(fileContent);
  
      // 日付プロパティをDateオブジェクトに変換
      return tokens.map((token) => ({
        ...token,
        issuedAt: new Date(token.issuedAt),
        expiresAt: new Date(token.expiresAt),
      }));
    } catch (error) {
      console.error("Failed to load tokens from S3:", error);
      return []; // 初期値として空配列を返す
    }
  };
  
